import { createFileRoute } from "@tanstack/react-router";
import { ApexNewsPage } from "@/features/admin/apex-news/apex-news-page";

export const Route = createFileRoute("/admin/apex-news")({
  staticData: {
    title: "新闻抓取",
  },
  component: RouteComponent,
  ssr: false,
});

function RouteComponent() {
  return <ApexNewsPage />;
}
